import { Component, Inject } from '@angular/core'
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-change-bot-name',
  templateUrl: './change-bot-name.component.html',
  styleUrls: ['./change-bot-name.component.scss'],
  standalone: false,
})
export class ChangeBotNameComponent {
  readonly title: string
  readonly closeLabel: string
  readonly cancelLabel: string
  readonly updateLabel: string

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translate: TranslateService
  ) {
    this.title = this.translate.instant('shared.changeBotName.title')
    this.closeLabel = this.translate.instant('common.close')
    this.cancelLabel = this.translate.instant('common.cancel')
    this.updateLabel = this.translate.instant('shared.changeBotName.update')
  }

  onCancel() {
    this.dialogRef.close()
  }
}
